var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{staticClass:"l-w-230",class:{ 'is-loading': _vm.isLoading },attrs:{"fsize":"f14","variant":"main","disabled":_vm.isDisabled},on:{"click":_vm.click}},[_c('span',[_vm._v("ダウンロード")])])
}
var staticRenderFns = []

export { render, staticRenderFns }